<template>
  <div>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <b-row>
        <b-col sm="12">
          <h2>
            Wat zijn uw gegevens?
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            Let op: Uw naam en geboortedatum moeten overeen komen met uw gegevens zoals vermeld op uw paspoort / ID kaart.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-transgender-alt"></i>
          <label for="letterhead">Geslacht*</label>
        </b-col>
        <b-col sm="6">
          <b-form-select
                  :options="formData.letterhead"
                  :disabled="this.noInput"
                  v-model="$v.user.letterhead.$model"
                  required
                  :state="$v.user.letterhead.$dirty ? !$v.user.letterhead.$invalid : undefined"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-tag"></i>
          <label for="initials">Voorletters*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="initials"
                  size="sm"
                  maxlength="8"
                  :disabled="this.noInput"
                  v-model="$v.user.initials.$model"
                  placeholder=""
                  required
                  @change="onChangeInitials"
                  :state="$v.user.initials.$dirty ? !$v.user.initials.$invalid : undefined"
          />
          <b-form-text v-if="this.user.initials.length > 6">Let op: Het gaat hier om uw <strong>voorletters</strong>, niet uw voornaam.</b-form-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-user-tag"></i>
          <label for="lastname">Achternaam*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="lastname"
                  :disabled="this.noInput"
                  v-model="$v.user.lastname.$model"
                  size="sm"
                  placeholder=""
                  required
                  :state="$v.user.lastname.$dirty ? !$v.user.lastname.$invalid : undefined"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-calendar-star"></i>
          <label for="dob">Geboortedatum*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="dob"
                  size="sm"
                  :value="dutchDate(user.dob)"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h2>
            Hoe kunnen we u bereiken?
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-envelope"></i>
          <label for="email">E-mailadres*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="email"
                  id="email"
                  :disabled="this.noInput"
                  v-model="$v.user.email.$model"
                  size="sm"
                  placeholder=""
                  required
                  :state="$v.user.email.$dirty ? !$v.user.email.$invalid : undefined"

          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-envelope-open"></i>
          <label for="cc_email">Mail ook naar</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="email"
                  id="cc_email"
                  :disabled="this.noInput"
                  v-model="$v.user.cc_email.$model"
                  size="sm"
                  placeholder=""
                  :state="secondaryEmailState"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-phone"></i>
          <label for="clt_mob">Telefoonnummer*</label>
        </b-col>
        <b-col :sm="showSecondNumber ? 6 : 5" :cols="showSecondNumber ? 12 : 10">
          <b-form-input
                  type="text"
                  id="clt_mob"
                  :disabled="this.noInput"
                  v-model="$v.user.phone.mobile.$model"
                  size="sm"
                  placeholder=""
                  required
                  @change="onChangePhone"
                  :state="$v.user.phone.mobile.$dirty ? !$v.user.phone.mobile.$invalid : undefined"
          />
        </b-col>
        <b-col class="addExtraPhone" sm="1" cols="2" v-if="!showSecondNumber" @click="showSecondNumber = true">
          <i class="fad fax fa-plus-circle"></i>
        </b-col>
      </b-row>
      <b-row v-if="showSecondNumber">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-phone-plus"></i>
          <label for="clt_tel">Telefoonnummer 2</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="clt_tel"
                  :disabled="this.noInput"
                  v-model="$v.user.phone.landline.$model"
                  size="sm"
                  placeholder=""
                  @change="onChangePhone"
                  :state="secondaryPhoneState"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h2>
            Waar woont u nu?
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-search-location"></i>
          <label for="zipcode">Postcode*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="zipcode"
                  :disabled="this.noInput"
                  v-model="$v.user.zipcode.$model"
                  maxlength="7"
                  size="sm"
                  placeholder=""
                  @input="zipcodeCheck"
                  :state="$v.user.zipcode.$dirty ? !$v.user.zipcode.$invalid : undefined"
                  required
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-search-location"></i>
          <label for="housenumber">Huisnummer*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="housenumber"
                  :disabled="this.noInput"
                  v-model="$v.user.housenumber.$model"
                  size="sm"
                  placeholder=""
                  @focus="setActiveInput('housenumber')"
                  @blur="setActiveInput(null)"
                  @input="zipcodeCheck"
                  required
                  :state="$v.user.housenumber.$dirty ? !$v.user.housenumber.$invalid : undefined"
          />
          <div class="card d-none d-lg-block info-card" v-if="activeInput === 'housenumber'">
            <div class="card-body">
              Dit is inclusief eventuele toevoegingen
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-road"></i>
          <label for="street">Straat</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="street"
                  :disabled="this.noInput"
                  v-model="user.street"
                  size="sm"
                  placeholder="Wordt automatisch ingevuld"
                  disabled
                  :state="$v.user.city.$dirty ? !$v.user.city.$invalid : undefined"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-city"></i>
          <label for="city">Woonplaats</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="city"
                  :disabled="this.noInput"
                  v-model="user.city"
                  size="sm"
                  placeholder="Wordt automatisch ingevuld"
                  disabled
                  :state="$v.user.city.$dirty ? !$v.user.city.$invalid : undefined"
          />
        </b-col>
      </b-row>

      
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h2>
            Uw persoonlijk belastbaar inkomen
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            Vul hier uw persoonlijke inkomen in. Zorg ervoor dat u beschikt over een inkomensverklaring van de Belastingdienst. Neem uw ‘verzamelinkomen’ of ‘geregistreerd inkomen’ over van uw inkomensverklaring. De inkomensverklaring kunt u gratis opvragen bij Mijn Belastingdienst.
          </p>
          <p>
            Wij zijn verplicht uw inkomen om te rekenen naar het huidige jaar. Dit doen wij door de Rijksoverheid vastgestelde percentage. De omrekenfactor voor 2023 is 1,1279 en voor 2024 is dit 1,0413.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-wallet"></i>
          <label for="income">Mijn inkomen per jaar*</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  type="text"
                  id="income"
                  :disabled="this.noInput"
                  v-model="$v.user.income.$model"
                  size="sm"
                  placeholder=""
                  @blur="setActiveInput(null)"
                  @focus="setActiveInput('income')"
                  @change="onChangeIncome"
                  required
                  :state="$v.user.income.$dirty ? !$v.user.income.$invalid : undefined"
          />
        </b-col>
        <b-col offset-sm="3" sm="9" offset-xl="6" xl="6">
          <div class="disconnectedButtons">
            <b-button variant="info" size="sm" class="pull-left" @click="setCalculatorState(true)">
              Rekenhulp
            </b-button>
            <b-button variant="info" size="sm" class="pull-left" @click="$bvModal.show('bdPopup')">
              Belastingdienst
            </b-button>
          </div>
          <div class="card d-none d-lg-block info-card" v-if="activeInput === 'income'">
            <div class="card-body">
              Vul het bedrag in zonder punt en zonder cijfers achter de komma.
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="d-block d-lg-none" v-if="activeInput === 'income'">
        <b-col sm="12">
          <p class="text-muted">
            <i>
              Vul het bedrag in zonder punt en zonder cijfers achter de komma.
            </i>
          </p>
        </b-col>
      </b-row>
      <br/>
      <b-row v-if="user.aow">
        <b-col>
          <p>
            Er is vanaf 2022 een uitzondering voor ouderen met vermogen. Een corporatie mag ook een woning toewijzen met een huur boven de huurtoeslaggrenzen als het vermogen van een oudere hoger is dan €141.896 (alleenstaanden, prijspeil 2025) of €179.429 (meerpersoonshuishoudens, prijspeil 2025).
          </p>
        </b-col>
      </b-row>
      <b-row v-if="user.aow">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-wallet"></i>
          <label for="capital">Mijn eigen vermogen is</label>
        </b-col>
        <b-col sm="6">
          <b-form-select
              :options="formData.capital"
              :disabled="this.noInput"
              v-model="$v.user.capital.$model"
              required
              :state="$v.user.capital.$dirty ? !$v.user.capital.$invalid : undefined"
          />
        </b-col>
      </b-row>
      <keep-alive>
        <IncomeCalculator :open="calculatorModal" @calculatorClosed="setCalculatorState(false)"
                          @calculatorEmitVal="setValueFromCalculator"></IncomeCalculator>
      </keep-alive>

      <br>
      <FormButtons @next="next" @previous="$emit('previous')"/>
    </template>

    <vuelidateErrorDialog :validator="$v.user" :state="errDialogVisible" parent="NAW" @onClose="errDialogVisible = false"/>
  </div>
</template>

<script>
import { geodataService } from '@/_services'
import { formatInitials, formatPhone, formatIncome } from '@/_helpers/transformers'
import { dutchPhone, dutchZipcode } from '@/_helpers/validators'
import { required, email } from 'vuelidate/lib/validators'
import IncomeCalculator from './IncomeCalculator'
import FormLoader from '@/components/_registration/FormLoader'
import FormButtons from '@/components/_registration/FormButtons'
import dateTransformers from '@/mixins/dateTransformers'
import vuelidateErrorDialog from "@/components/VuelidateErrorDialog";

export default {
  name: 'Naw',
  components: { IncomeCalculator, FormLoader, FormButtons, vuelidateErrorDialog },
  props: [
    'noInput',
  ],
  mixins: [dateTransformers],
  data: () => {
    return {
      highlightInvalid: false,
      errDialogVisible: false,
      showSecondNumber: false,
      user: {
        letterhead: '',
        email: '',
        phone: {
          mobile: '',
          landline: ''
        },
        initials: '',
        lastname: '',
        cc_email: '',
        zipcode: '',
        housenumber: '',
        street: '',
        city: '',
        income: '',
        dob: '',
        aow: 0,
        capital: 0
      },
      bdYear: new Date().getFullYear(),
      loading: false,
      activeInput: '',
      formData: {
        letterhead: [
          { text: 'Kies...', value: '' },
          { text: 'Man', value: 'M' },
          { text: 'Vrouw', value: 'F' },
          { text: 'Anders', value: 'B' }
        ],
        capital: [
          { text: 'minder dan 141.896', value: 0 },
          { text: 'meer dan 141.896', value: 1 },
          { text: 'meer dan 179.429', value: 2 }
        ]
      },
      calculatorModal: false
    }
  },
  validations: {
    user: {
      letterhead: { required },
      email: { required, email },
      phone: {
        mobile: { required, dutchPhone },
        landline: { dutchPhone }
      },
      initials: { required },
      lastname: { required },
      cc_email: { email },
      zipcode: { required, dutchZipcode },
      housenumber: { required },
      city: { required },
      income: { required },
      capital: {}
    }
  },
  computed: {
    validated () {
      return !this.$v.$invalid
    },
    secondaryEmailState(){
      if(this.user.cc_email === '')
        return null // prevent empty field from showing a checkmark

      return this.$v.user.cc_email.$dirty ? !this.$v.user.cc_email.$invalid : undefined
    },
    secondaryPhoneState(){
      if(this.user.phone.landline === '')
        return null // prevent empty field from showing a checkmark
      return this.$v.user.phone.landline.$dirty ? !this.$v.user.phone.landline.$invalid : undefined
    }
  },
  watch: {
    validated (val) {
      this.$emit('validated', val)
    },
    highlightInvalid (val) {
      if (val) {
        this.$v.$touch()
      }
    },
  },
  mounted () {
    this.fetchData()
    if(this.$store.state.registration.errors[this.$options.name] !== undefined) {
      this.highlightInvalid = true
    }
  },

  activated () {
    this.fetchData()
  },

  methods: {
    next () {
      this.$v.$touch()
      if (this.validated) {
        this.submit()
      } else {
        this.highlightInvalid = true
        this.errDialogVisible = true
      }
    },
    submit () {
      let _this = this

      /* Sanitize income */
      this.user.income = this.user.income.replace(/[^0-9]/g, '')

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.user)
      }

      const url = `${process.env.VUE_APP_API_URL}/user/steps/naw`

      this.$http.fetch(url, requestOptions)
              .then(function (response) {
                if (response.status === 200) {
                  _this.$emit('next')
                }
              })
    },
    setActiveInput (data) {
      if (data !== this.activeInput) {
        this.activeInput = data
      }
    },

    async zipcodeCheck () {
      let result = await geodataService.getAddress(this.user.zipcode, this.user.housenumber)
      this.user.street = result.street
      this.user.zipcode = result.zipcode
      this.$v.user.city.$model = result.city
    },

    setCalculatorState (tog) {
      this.calculatorModal = tog
    },

    setValueFromCalculator (income) {
      this.$v.user.income.$model = formatIncome(income)
    },

    onChangeInitials() {
      this.user.initials = formatInitials(this.user.initials)
    },

    onChangePhone() {
      this.user.phone.landline = formatPhone(this.user.phone.landline)
      this.user.phone.mobile = formatPhone(this.user.phone.mobile)
    },

    onChangeIncome() {
      this.user.income = formatIncome(this.user.income)
    },

    fetchData () {
      this.loading = true
      let _this = this

      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }

      this.$http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/naw`, options)
              .then(response => response.json())
              .then(result => {
                _this.user.cc_email = result.cc_email
                _this.user.city = result.city
                _this.user.dob = result.dob
                _this.user.capital = result.capital
                _this.user.aow = result.aow
                _this.user.email = result.email
                _this.user.housenumber = result.housenumber
                _this.user.income = formatIncome(result.income)
                _this.user.initials = formatInitials(result.initials)
                _this.user.lastname = result.lastname
                _this.user.letterhead = result.letterhead
                _this.user.phone = result.phone
                _this.user.street = result.street
                _this.user.zipcode = result.zipcode

                _this.user.phone.landline = formatPhone(result.phone.landline)
                _this.user.phone.mobile = formatPhone(result.phone.mobile)

                if(result.phone.landline.length > 5) {
                  this.showSecondNumber = true
                }
              })
              .catch(function (err) {
                console.log('Fetch Error :', err)
              }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
